/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { STETHMagician, STETHMagicianInterface } from "../STETHMagician";

const _abi = [
  {
    inputs: [],
    name: "InvalidAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "CURVE_POOL",
    outputs: [
      {
        internalType: "contract ICurvePoolLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STETH_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WSTETH",
    outputs: [
      {
        internalType: "contract IWstETHLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type STETHMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: STETHMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class STETHMagician__factory extends ContractFactory {
  constructor(...args: STETHMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "STETHMagician";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<STETHMagician> {
    return super.deploy(overrides || {}) as Promise<STETHMagician>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): STETHMagician {
    return super.attach(address) as STETHMagician;
  }
  connect(signer: Signer): STETHMagician__factory {
    return super.connect(signer) as STETHMagician__factory;
  }
  static readonly contractName: "STETHMagician";
  public readonly contractName: "STETHMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): STETHMagicianInterface {
    return new utils.Interface(_abi) as STETHMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): STETHMagician {
    return new Contract(address, _abi, signerOrProvider) as STETHMagician;
  }
}
